/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "oldContract",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newContract",
                type: "address",
            },
        ],
        name: "ContractUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint32",
                name: "index",
                type: "uint32",
            },
        ],
        name: "GuardianSetAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint16",
                name: "targetChainId",
                type: "uint16",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "sequence",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "nonce",
                type: "uint32",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "payload",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint8",
                name: "consistencyLevel",
                type: "uint8",
            },
        ],
        name: "LogMessagePublished",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        stateMutability: "payable",
        type: "fallback",
    },
    {
        inputs: [],
        name: "chainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getCurrentGuardianSetIndex",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "index",
                type: "uint32",
            },
        ],
        name: "getGuardianSet",
        outputs: [
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "keys",
                        type: "address[]",
                    },
                    {
                        internalType: "uint32",
                        name: "expirationTime",
                        type: "uint32",
                    },
                ],
                internalType: "struct Structs.GuardianSet",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getGuardianSetExpiry",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
        ],
        name: "governanceActionIsConsumed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceChainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceContract",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "impl",
                type: "address",
            },
        ],
        name: "isInitialized",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "messageFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "emitter",
                type: "address",
            },
            {
                internalType: "uint16",
                name: "targetChainId",
                type: "uint16",
            },
        ],
        name: "nextSequence",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVM",
                type: "bytes",
            },
        ],
        name: "parseAndVerifyVM",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "version",
                        type: "uint8",
                    },
                    {
                        internalType: "uint32",
                        name: "timestamp",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "nonce",
                        type: "uint32",
                    },
                    {
                        internalType: "uint16",
                        name: "emitterChainId",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "targetChainId",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "emitterAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint64",
                        name: "sequence",
                        type: "uint64",
                    },
                    {
                        internalType: "uint8",
                        name: "consistencyLevel",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes",
                        name: "payload",
                        type: "bytes",
                    },
                    {
                        internalType: "uint32",
                        name: "guardianSetIndex",
                        type: "uint32",
                    },
                    {
                        components: [
                            {
                                internalType: "bytes32",
                                name: "r",
                                type: "bytes32",
                            },
                            {
                                internalType: "bytes32",
                                name: "s",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint8",
                                name: "v",
                                type: "uint8",
                            },
                            {
                                internalType: "uint8",
                                name: "guardianIndex",
                                type: "uint8",
                            },
                        ],
                        internalType: "struct Structs.Signature[]",
                        name: "signatures",
                        type: "tuple[]",
                    },
                    {
                        internalType: "bytes32",
                        name: "hash",
                        type: "bytes32",
                    },
                ],
                internalType: "struct Structs.VM",
                name: "vm",
                type: "tuple",
            },
            {
                internalType: "bool",
                name: "valid",
                type: "bool",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedUpgrade",
                type: "bytes",
            },
        ],
        name: "parseContractUpgrade",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "newContract",
                        type: "address",
                    },
                ],
                internalType: "struct GovernanceStructs.ContractUpgrade",
                name: "cu",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedUpgrade",
                type: "bytes",
            },
        ],
        name: "parseGuardianSetUpgrade",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        components: [
                            {
                                internalType: "address[]",
                                name: "keys",
                                type: "address[]",
                            },
                            {
                                internalType: "uint32",
                                name: "expirationTime",
                                type: "uint32",
                            },
                        ],
                        internalType: "struct Structs.GuardianSet",
                        name: "newGuardianSet",
                        type: "tuple",
                    },
                    {
                        internalType: "uint32",
                        name: "newGuardianSetIndex",
                        type: "uint32",
                    },
                ],
                internalType: "struct GovernanceStructs.GuardianSetUpgrade",
                name: "gsu",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedSetMessageFee",
                type: "bytes",
            },
        ],
        name: "parseSetMessageFee",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "messageFee",
                        type: "uint256",
                    },
                ],
                internalType: "struct GovernanceStructs.SetMessageFee",
                name: "smf",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedTransferFees",
                type: "bytes",
            },
        ],
        name: "parseTransferFees",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "recipient",
                        type: "bytes32",
                    },
                ],
                internalType: "struct GovernanceStructs.TransferFees",
                name: "tf",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVM",
                type: "bytes",
            },
        ],
        name: "parseVM",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "version",
                        type: "uint8",
                    },
                    {
                        internalType: "uint32",
                        name: "timestamp",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "nonce",
                        type: "uint32",
                    },
                    {
                        internalType: "uint16",
                        name: "emitterChainId",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "targetChainId",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "emitterAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint64",
                        name: "sequence",
                        type: "uint64",
                    },
                    {
                        internalType: "uint8",
                        name: "consistencyLevel",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes",
                        name: "payload",
                        type: "bytes",
                    },
                    {
                        internalType: "uint32",
                        name: "guardianSetIndex",
                        type: "uint32",
                    },
                    {
                        components: [
                            {
                                internalType: "bytes32",
                                name: "r",
                                type: "bytes32",
                            },
                            {
                                internalType: "bytes32",
                                name: "s",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint8",
                                name: "v",
                                type: "uint8",
                            },
                            {
                                internalType: "uint8",
                                name: "guardianIndex",
                                type: "uint8",
                            },
                        ],
                        internalType: "struct Structs.Signature[]",
                        name: "signatures",
                        type: "tuple[]",
                    },
                    {
                        internalType: "bytes32",
                        name: "hash",
                        type: "bytes32",
                    },
                ],
                internalType: "struct Structs.VM",
                name: "vm",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "numGuardians",
                type: "uint256",
            },
        ],
        name: "quorum",
        outputs: [
            {
                internalType: "uint256",
                name: "numSignaturesRequiredForQuorum",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_vm",
                type: "bytes",
            },
        ],
        name: "submitContractUpgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_vm",
                type: "bytes",
            },
        ],
        name: "submitNewGuardianSet",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_vm",
                type: "bytes",
            },
        ],
        name: "submitSetMessageFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_vm",
                type: "bytes",
            },
        ],
        name: "submitTransferFees",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "r",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "s",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "v",
                        type: "uint8",
                    },
                    {
                        internalType: "uint8",
                        name: "guardianIndex",
                        type: "uint8",
                    },
                ],
                internalType: "struct Structs.Signature[]",
                name: "signatures",
                type: "tuple[]",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "keys",
                        type: "address[]",
                    },
                    {
                        internalType: "uint32",
                        name: "expirationTime",
                        type: "uint32",
                    },
                ],
                internalType: "struct Structs.GuardianSet",
                name: "guardianSet",
                type: "tuple",
            },
        ],
        name: "verifySignatures",
        outputs: [
            {
                internalType: "bool",
                name: "valid",
                type: "bool",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "version",
                        type: "uint8",
                    },
                    {
                        internalType: "uint32",
                        name: "timestamp",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "nonce",
                        type: "uint32",
                    },
                    {
                        internalType: "uint16",
                        name: "emitterChainId",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "targetChainId",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "emitterAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint64",
                        name: "sequence",
                        type: "uint64",
                    },
                    {
                        internalType: "uint8",
                        name: "consistencyLevel",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes",
                        name: "payload",
                        type: "bytes",
                    },
                    {
                        internalType: "uint32",
                        name: "guardianSetIndex",
                        type: "uint32",
                    },
                    {
                        components: [
                            {
                                internalType: "bytes32",
                                name: "r",
                                type: "bytes32",
                            },
                            {
                                internalType: "bytes32",
                                name: "s",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint8",
                                name: "v",
                                type: "uint8",
                            },
                            {
                                internalType: "uint8",
                                name: "guardianIndex",
                                type: "uint8",
                            },
                        ],
                        internalType: "struct Structs.Signature[]",
                        name: "signatures",
                        type: "tuple[]",
                    },
                    {
                        internalType: "bytes32",
                        name: "hash",
                        type: "bytes32",
                    },
                ],
                internalType: "struct Structs.VM",
                name: "vm",
                type: "tuple",
            },
        ],
        name: "verifyVM",
        outputs: [
            {
                internalType: "bool",
                name: "valid",
                type: "bool",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "targetChainId",
                type: "uint16",
            },
            {
                internalType: "uint32",
                name: "nonce",
                type: "uint32",
            },
            {
                internalType: "bytes",
                name: "payload",
                type: "bytes",
            },
            {
                internalType: "uint8",
                name: "consistencyLevel",
                type: "uint8",
            },
        ],
        name: "publishMessage",
        outputs: [
            {
                internalType: "uint64",
                name: "sequence",
                type: "uint64",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
export class Implementation__factory extends ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
Implementation__factory.bytecode = _bytecode;
Implementation__factory.abi = _abi;
